import Default from './default';


const Cards = {
  Default,
 
};

export default Cards;